import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ModalComponent } from '@app/v2/shared/components/modal/modal.component'
import { ModalService } from '@app/v2/shared/services/modal.service'

@Component({
  selector: 'app-unsaved-changes-modal',
  standalone: true,
  imports: [ModalComponent],
  templateUrl: './unsaved-changes-modal.component.html',
  styleUrl: './unsaved-changes-modal.component.scss'
})
export class UnsavedChangesModalComponent {
  @Input() id = 'unsaved-changes-modal'

  @Output() saveChanges = new EventEmitter<void>()
  @Output() cancel = new EventEmitter<void>()
  @Output() dismissed = new EventEmitter<void>()
  private _actionTaken = false

  constructor(private _modalService: ModalService) {}

  /**
   * @description Save changes and close the modal
   */
  public onSaveChanges(): void {
    this._actionTaken = true
    this.saveChanges.emit()
    if (this._modalService.isModalOpen(this.id)) this._modalService.toggleModal(this.id)
  }

  /**
   * @description Discard changes and close the modal
   */
  public discardChanges(): void {
    this._actionTaken = true
    this.cancel.emit()
    if (this._modalService.isModalOpen(this.id)) this._modalService.toggleModal(this.id)
  }

  /**
   * @description Close the modal
   */
  public onCloseModal(): void {
    if (this._actionTaken) {
      this._actionTaken = false
      return
    }
    this.dismissed.emit()
  }
}
